import apiClient from "../client/apiClient";
import { ENDPOINTS } from "../config/endpoints";
import { normalizeApiError } from "../utils/handleError";
import { unwrapApiResponse } from "../utils/unWrapApiResponse.js";

/**
 * Generate DigiLocker URL for KYC
 * @param {Object} payload
 */
export const generateDigilockerUrl = async (payload) => {
  try {
    const response = await apiClient.post(
      ENDPOINTS.DIGILOCKER_GENERATE_URL,
      { properties: payload },
      {
        params: {
          source: "web_app",
        },
      }
    );
    return unwrapApiResponse(response, {
      extract: "resultsRaw",
      fallbackMessage: "Failed to generate DigiLocker URL",
    });
  } catch (error) {
    throw normalizeApiError(error);
  }
};
